import { deferredTestTrack } from '@betterment/shared-components';
import { changeUser, initialize as initializeBraze } from '@braze/web-sdk';
import { captureException } from '@sentry/browser';

import { BrazeSdkStatus } from './data';

import appConfig from '../Shared/appConfig';

class BrazeInitializer {
  status: BrazeSdkStatus = 'uninitialized';

  /*
    This method handles the actual initialization of the Braze SDK that's being used on the useBrazeContentCard hook.
    This module is being shared between all react apps that reference this module. The Braze SDK uses the external id
    which is the test track visitor id to identify the user in Braze.
  */
  async initialize(): Promise<void> {
    try {
      const testTrack = await deferredTestTrack.promise;

      const isInitialized = initializeBraze(appConfig.brazePublicApiKey || '', {
        baseUrl: appConfig.brazeSdkBaseUrl || '',
        enableLogging: false,
      });

      if (isInitialized) {
        changeUser(testTrack.visitorId);
        this.status = 'initialized';
      } else {
        this.status = 'failed';
        throw new Error('Braze SDK failed to initialize');
      }
    } catch (error) {
      this.status = 'failed';
      captureException(error);
      throw error;
    }
  }

  reset(): void {
    this.status = 'uninitialized';
  }
}

export const brazeInitializer = new BrazeInitializer();
